export enum ViewMode {
    GridView = 'grid',
    ListView = 'list',
}
